/** Mensagem legível para falhas de API dos relatórios BI (evita JSON de 403 ACL no notify). */
export function formatBiHttpError(status, raw) {
	if (status === 403 && raw) {
		try {
			const j = JSON.parse(raw);
			if (j.search_hint && j.method && j.path) {
				return `Sem permissão para este relatório (${j.search_hint}). Solicite ao administrador a inclusão do endpoint ${j.method} ${j.path} no seu grupo.`;
			}
		} catch (e) { /* ignore */ }
	}
	return raw || (status ? `Erro ${status}` : 'Falha na requisição');
}
